import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

function money(value: unknown): string {
  const n = Number(value || 0);
  return `$${new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(n)}`;
}

function presentNames(session: any): string[] {
  const names = new Map<number, string>();
  for (const row of session.roster || []) names.set(row.userId, row.fullName);
  return (session.attendance || []).map((row: any) => names.get(row.userId) || String(row.userId));
}

function linesOf(item: any): any[] {
  return item?.summary?.lines || [];
}

function when(session: any): string {
  const date = session.heldAt ? new Date(session.heldAt) : new Date();
  return date.toLocaleString('es-CL', { dateStyle: 'full', timeStyle: 'short' });
}

export function downloadAgenda(session: any): void {
  const doc = new jsPDF();
  let y = 16;
  doc.setFontSize(16);
  doc.text('Agenda de sesión', 14, y);
  y += 8;
  doc.setFontSize(11);
  doc.text(`${session.placeName || 'Lugar por definir'} · ${when(session)}`, 14, y);
  y += 6;
  doc.text(`Comisión ${session.roleName} · ${session.yearMonth}`, 14, y);
  y += 8;

  for (const item of session.items || []) {
    doc.setFontSize(12);
    doc.text(`${item.sortOrder}. ${item.title}`, 14, y);
    y += 4;
    if (item.grouped) {
      autoTable(doc, {
        startY: y,
        head: [['N°', 'Campo', 'Socio', 'Patente', 'Modelo', 'Marca', 'Año', 'Valor']],
        body: linesOf(item).map((line, index) => [
          index + 1, line.campo, line.socio, line.plate, line.model, line.brand, line.year, money(line.valor)
        ]),
        styles: { fontSize: 8 }
      });
      y = (doc as any).lastAutoTable.finalY + 8;
    } else {
      const line = linesOf(item)[0] || {};
      const text = item.summary?.isClaim
        ? `${line.description || 'Informe de siniestro'}\nPresupuesto ${money(line.budget)} · Deducible ${item.approvedDeductible ?? line.deductible ?? 0}% · Reembolso ${money(item.approvedAmount)}`
        : `${line.socio || ''} ${line.plate || ''}`.trim();
      const split = doc.splitTextToSize(text, 180);
      doc.setFontSize(10);
      doc.text(split, 14, y + 4);
      y += 8 + split.length * 5;
    }
    if (y > 260) { doc.addPage(); y = 16; }
  }
  doc.save(`agenda-${session.yearMonth}.pdf`);
}

export function downloadActa(session: any): void {
  const doc = new jsPDF();
  let y = 16;
  doc.setFontSize(9);
  doc.text('Documento confidencial. Uso interno de la iglesia.', 14, y);
  y += 10;
  doc.setFontSize(14);
  doc.text('ACTA DE JUNTA DIRECTIVA IASD', 14, y);
  y += 8;
  doc.setFontSize(11);
  doc.text('Iglesia Adventista del Séptimo Día', 14, y);
  y += 6;
  doc.text(`${session.placeName || 'Lugar'} · ${when(session)}`, 14, y);
  y += 8;
  doc.setFontSize(12);
  doc.text('Presencial', 14, y);
  y += 6;
  doc.setFontSize(10);
  const names = presentNames(session);
  const listed = doc.splitTextToSize(names.length ? names.join(', ') : 'Sin asistencia registrada', 180);
  doc.text(listed, 14, y);
  y += listed.length * 5 + 6;
  doc.text(`Oración inicial: ${session.prayer || ''}`, 14, y);
  y += 6;
  doc.text(`Meditación: ${session.meditation || ''}`, 14, y);
  y += 10;

  for (const item of (session.items || []).filter((row: any) => row.phase === 'APROBADO')) {
    if (y > 250) { doc.addPage(); y = 16; }
    const code = item.agreementCode || '';
    const line = linesOf(item)[0] || {};
    const heading = item.grouped || !item.summary?.isClaim
      ? `${code} ${item.processName || item.title}`.trim()
      : `${code} ${item.processName || 'Siniestro'} – ${line.socio || ''}`.trim();
    doc.setFontSize(12);
    doc.text(heading, 14, y);
    y += 6;
    if (item.grouped) {
      autoTable(doc, {
        startY: y,
        head: [['N°', 'Campo', 'Socio', 'Patente', 'Modelo', 'Marca', 'Año', 'Valor']],
        body: linesOf(item).map((row, index) => [
          index + 1, row.campo, row.socio, row.plate, row.model, row.brand, row.year, money(row.valor)
        ]),
        styles: { fontSize: 8 }
      });
      y = (doc as any).lastAutoTable.finalY + 6;
      doc.setFontSize(11);
      doc.text('VOTADO aprobar.', 14, y);
      y += 10;
    } else if (item.summary?.isClaim) {
      const pct = item.approvedDeductible ?? line.deductible ?? 0;
      const text = `VOTADO aprobar ${money(item.approvedAmount)} con un deducible de ${pct}% según reglamento.`;
      doc.setFontSize(11);
      doc.text(doc.splitTextToSize(text, 180), 14, y);
      y += 14;
    } else {
      doc.setFontSize(11);
      doc.text('VOTADO aprobar.', 14, y);
      y += 10;
    }
  }
  doc.save(`acta-${session.yearMonth}.pdf`);
}
